import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { sumBy, map, toString, sortBy, includes, isEmpty } from "lodash"

import RAGIcon from 'FoundationalComponents/RAGIcon'
import Popup from 'reactjs-popup'


const DefaultCoverageDetails = (value) => {
  switch (toString(value)) {
    case 'true': return { sort: 1, color: 'green', icon: 'check', title: 'Integrated / Set by contract' }
    case 'false': return { sort: 2, color: 'red', icon: 'times', title: 'Not Integrated' }
    case 'Data Source not integrated to Incognita': return { sort: 4, color: 'lightgrey', icon: 'minus-hexagon', title: 'Data Source not integrated to Incognita' }
    case 'N/A': return { sort: 5, color: 'grey', icon: 'minus', title: 'N/A' }
    default: return { sort: 3, color: 'red', icon: 'times' }
  }
}

const AntiVirusDetails = (value) => {
  switch (value) {
    case 'YesAndHasAntivirusWithStatusRunningAndUpToDate':                 return { sort: 2, color: 'amber', icon: 'check', title: 'Covered, Running up to date, Wrong Antivirus Product' }
    case 'YesAndHasAntivirusWithStatusRunningAndNotUpToDate':              return { sort: 3, color: 'amber', icon: 'check', title: 'Covered, Running not up to date, Wrong Antivirus Product' }
    case 'YesAndHasAntivirusWithStatusNotDetected':                        return { sort: 4, color: 'red', icon: 'check', title: 'Covered and not detected, Wrong Antivirus Product' }
    case 'YesAndHasAntivirusWithStatusNotRunning':                         return { sort: 5, color: 'red', icon: 'check', title: 'Covered and not running, Wrong Antivirus Product' }
    case 'YesAndHasAntivirusWithStatusRunningAndUpToDateProductSophos':    return { sort: 6, color: 'green', icon: 'check', title: 'Covered and Running up to date' }
    case 'YesAndHasAntivirusWithStatusRunningAndNotUpToDateProductSophos': return { sort: 7, color: 'amber', icon: 'check', title: 'Covered and Running not up to date' }
    case 'YesAndHasAntivirusWithStatusNotDetectedProductSophos':           return { sort: 8, color: 'red', icon: 'check', title: 'Covered and not detected' }
    case 'YesAndHasAntivirusWithStatusNotRunningProductSophos':            return { sort: 9, color: 'red', icon: 'check', title: 'Covered and not running' }
    case 'YesAndHasAntivirusWithStatusUnknownProductSophos':               return { sort: 10, color: 'green', icon: 'check', title: 'Covered and status unknown' }
    case 'YesAndHasAntivirusWithStatusUnknown':                            return { sort: 10, color: 'green', icon: 'check', title: 'Covered and status unknown, Wrong Antivirus Product' }
    case 'YesAndHasNotAntivirus':                                          return { sort: 11, color: 'red', icon: 'times', title: 'Covered and no antivirus' }
    case 'NoCoverage':                                                     return { sort: 12, color: 'grey', icon: 'minus', title: 'Not covered' }
    default:                                                               return { sort: 13, color: 'deeppink', icon: 'unicorn', title: 'Unknown' }
  }
}

const PatchingDetails = (value) => {
  switch (value) {
    case 'YesAndInDattoWithStatusFullyPatched':    return { sort: 2, color: 'green', icon: 'check', title: 'Covered in Datto and status Fully Patched' }
    case 'YesAndInDattoWithStatusApprovedPending': return { sort: 3, color: 'green', icon: 'check', title: 'Covered in Datto and status Approved pending' }
    case 'YesAndInDattoWithStatusRebootRequired':  return { sort: 4, color: 'amber', icon: 'check', title: 'Covered in Datto and status Reboot required' }
    case 'YesAndInDattoWithStatusUnknown':         return { sort: 5, color: 'amber', icon: 'check', title: 'Covered in Datto and status Unknown' }
    case 'YesAndInDattoWithStatusInstallError':    return { sort: 6, color: 'red', icon: 'check', title: 'Covered in Datto and status Install error' }
    case 'YesAndInDattoWithStatusNoPolicy':        return { sort: 7, color: 'red', icon: 'check', title: 'Covered in Datto and status No Policy' }
    case 'YesAndInDattoWithStatusNoData':          return { sort: 8, color: 'red', icon: 'check', title: 'Covered in Datto and status No Data' }
    case 'NoAndInDattoWithStatusFullyPatched':     return { sort: 9, color: 'red', icon: 'exclamation', title: 'Not covered, in Datto with status Fully Patched' }
    case 'NoAndInDattoWithStatusApprovedPending':  return { sort: 10, color: 'red', icon: 'exclamation', title: 'Not covered, in Datto with status Approved pending' }
    case 'NoAndInDattoWithStatusNoData':           return { sort: 11, color: 'red', icon: 'exclamation', title: 'Not covered, in Datto with status No data' }
    case 'NoAndInDattoWithStatusInstallError':     return { sort: 12, color: 'red', icon: 'exclamation', title: 'Not covered, in Datto with status Install error' }
    case 'NoAndInDattoWithStatusNoPolicy':         return { sort: 13, color: 'red', icon: 'exclamation', title: 'Not covered, in Datto with status No policy' }
    case 'NoAndInDattoWithStatusRebootRequired':   return { sort: 14, color: 'red', icon: 'exclamation', title: 'Not covered, in Datto with status Reboot required' }
    case 'NoAndInDattoWithStatusUnknown':          return { sort: 15, color: 'red', icon: 'exclamation', title: 'Not covered, in Datto with status Unknown' }
    case 'YesAndNotInDattoWithStatusUnknown':      return { sort: 16, color: 'red', icon: 'times', title: 'Covered, not in Datto and status Unknown' }
    case 'NoAndNotInDattoWithStatusUnknown':       return { sort: 17, color: 'grey', icon: 'minus', title: 'Not covered, not in Datto' }
    case 'Unsupported':                            return { sort: 18, color: 'grey', icon: 'minus', title: 'Unsupported' }
    default:                                       return { sort: 19, color: 'deeppink', icon: 'unicorn', title: 'Unknown' }
  }
}

const DataProtectionDetails = (value) => {
  switch (value) {
    case 'YesAndHasBackupWithStatusBackupInLast24':         return { sort: 2, color: 'green', icon: 'check', title: 'Covered with backup within last 24 hours' } 
    case 'YesAndInCommvaultWithStatusCompleted':            return { sort: 2, color: 'green', icon: 'check', title: 'Covered in Commvault with status Completed' } 
    case 'YesAndInCommvaultWithStatusRunning':              return { sort: 3, color: 'green', icon: 'check', title: 'Covered in Commvault with status Running' }
    case 'YesAndInCommvaultWithStatusCompletedWithErrors':  return { sort: 4, color: 'amber', icon: 'check', title: 'Covered in Commvault with status With errors' }
    case 'YesAndHasBackupWithStatusBackupNotInLast24':      return { sort: 4, color: 'amber', icon: 'check', title: 'Covered with backup within more than 24 hours' }
    case 'YesAndInCommvaultWithStatusFailed':               return { sort: 5, color: 'red', icon: 'check', title: 'Covered in Commvault with status Failed' }
    case 'YesAndNotInCommvaultWithStatusUnknown':           return { sort: 6, color: 'red', icon: 'times', title: 'Covered in Commvault with status Unknown' }
    case 'YesAndHasNotBackupWithStatusNoBackup':            return { sort: 6, color: 'red', icon: 'times', title: 'Covered with no backups' }
    case 'NoAndInCommvaultWithStatusCompleted':             return { sort: 7, color: 'red', icon: 'exclamation', title: 'Not Covered, in Commvault with status Completed' }
    case 'NoAndInCommvaultWithStatusRunning':               return { sort: 8, color: 'red', icon: 'exclamation', title: 'Not Covered, in Commvault with status Running' }
    case 'NoAndInCommvaultWithStatusCompletedWithErrors':   return { sort: 9, color: 'red', icon: 'exclamation', title: 'Not Covered, in Commvault with status With errors' }
    case 'NoAndInCommvaultWithStatusFailed':                return { sort: 10, color: 'red', icon: 'exclamation', title: 'Not Covered, in Commvault with status Failed' }
    case 'NoAndHasBackupWithStatusBackupInLast24':          return { sort: 10, color: 'red', icon: 'exclamation', title: 'Not Covered, in backups within last 24 hours' }
    case 'NoAndHasBackupWithStatusBackupNotInLast24':       return { sort: 11, color: 'red', icon: 'exclamation', title: 'Not Covered, in backups within more than last 24 hours' }
    case 'NoAndNotInCommvaultWithStatusUnknown':            return { sort: 11, color: 'grey', icon: 'minus', title: 'Not Covered, not in Commvault' }
    case 'NoAndHasNotBackupWithStatusNoBackup':             return { sort: 12, color: 'grey', icon: 'minus', title: 'Not Covered, not in backups' }
    default:                                                return { sort: 13, color: 'deeppink', icon: 'unicorn', title: 'Unknown' }
  }
}

const BackupDetails = (value) => {
  switch (value) {
    case 'BackupInLast24':    return { sort: 2, color: 'green', icon: 'check' }
    case 'BackupNotInLast24': return { sort: 3, color: 'amber', icon: 'check' }
    case 'NoBackup':          return { sort: 4, color: 'red',   icon: 'times' }
    case 'N/A':               return { sort: 5, color: 'grey',   icon: 'minus' }
    default:                  return { sort: 6, color: 'deeppink',   icon: 'unicorn' }
  }
}

const MonitoringDetails = (value) => {
  switch (value) {
    case 'YesAndInDatto':             return { sort: 2, color: 'green', icon: 'check', title: 'Covered and in Datto' }
    case 'DattoAndInDatto':           return { sort: 3, color: 'green', icon: 'check', title: 'Covered by Datto and in Datto' }
    case 'LogicMonitorAndInDatto':    return { sort: 4, color: 'grey', icon: 'minus-hexagon', title: 'Covered by LogicMonitor and in Datto' }
    case 'LogicMonitorAndNotInDatto': return { sort: 5, color: 'grey', icon: 'minus-hexagon', title: 'Covered by LogicMonitor and not in Datto' }
    case 'PRTGAndInDatto':            return { sort: 6, color: 'grey', icon: 'minus-hexagon', title: 'Covered by PRTG and in Datto' }
    case 'PRTGAndNotInDatto':         return { sort: 7, color: 'grey', icon: 'minus-hexagon', title: 'Covered by PRTG and not in Datto' }
    case 'NoAndNotInDatto':           return { sort: 8, color: 'grey', icon: 'minus', title: 'Not covered and not in Datto' }
    case 'NoAndInDatto':              return { sort: 9, color: 'red',  icon: 'exclamation', title: 'Not covered and in Datto' }
    case 'DattoAndNotInDatto':        return { sort: 10, color: 'red', icon: 'times', title: 'Covered by Datto and not in Datto' }
    case 'YesAndNotInDatto':          return { sort: 11, color: 'red', icon: 'times', title: 'Covered and not in Datto' }
    default:                          return { sort: 12, color: 'red',  icon: 'times', title: 'Unknown' }
  }
}


const SummaryCell = ({ value }) => {
  const fullCount = sumBy(value, 'count')
  const colors = { green: 'success', red: 'danger', amber: 'warning', grey: 'dark', lightgrey: 'secondary', deeppink: 'pink-unicorn' }

  return (
    <ProgressBar>
      {map(sortBy(value, 'sort'), (status) => (
        <ProgressBar
          title={`${status.title}: ${status.count} / ${fullCount}`}
          variant={colors[status.color]}
          now={(status.count / fullCount) * 100}
          key={status.sort}
        />
      ))}
    </ProgressBar>
  )
}

const PatchingCell = ({ value }) =>  <RAGIcon {...PatchingDetails(value)} />
const MonitoringCell = ({ value }) =>  <RAGIcon {...MonitoringDetails(value)} />
const BackupCell = ({ value }) =>  <RAGIcon {...BackupDetails(value)} />
const AntiVirusCell = ({ value, antivirus_product }) => (
  <div style={{ textAlign: 'center' }}>
    <RAGIcon {...AntiVirusDetails(value)} />

    {antivirus_product}
  </div>
)

const DataProtectionCell = ({ value, details, vmID }) => {
  if (details) {  
    return (
      <Popup
        contentStyle={{ width: 'auto' }}
        key={`data_protection_${vmID}`}
        position='top center'
        on={['hover', 'focus']}
        trigger={<div><RAGIcon {...DataProtectionDetails(value)} /></div>}
      >
        {details}
      </Popup>
    )
  }

  return <RAGIcon {...DataProtectionDetails(value)} />
}



export {
  SummaryCell,
  AntiVirusCell,
  PatchingCell,
  MonitoringCell,
  BackupCell,
  BackupDetails,
  AntiVirusDetails,
  PatchingDetails,
  DefaultCoverageDetails,
  DataProtectionCell,
  DataProtectionDetails,
  MonitoringDetails
}
